import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {catchError, throwError} from 'rxjs';
import {HelperService} from 'src/app/helper.service';
import {NavBarComponent} from 'src/app/nav-bar/nav-bar.component';
import {BaseService} from '../../services/base.service';
import {SampleGroupInfo} from 'src/app/models/Sample-Group-Info';
import {SampleService} from 'src/app/services/sample.service';
import dayjs from "dayjs";
import {PinType} from 'src/app/models/pinType';
import {PinManagerService} from 'src/app/services/pin-manager.service';
import {MatDialog} from '@angular/material/dialog';
import {
    AddEditSoftTissueSampleComponent
} from 'src/app/dialogs/pin-rework-dialogs/add-edit-soft-tissue-sample/add-edit-soft-tissue-sample.component';
import {
    AddEditSoilSampleComponent
} from 'src/app/dialogs/pin-rework-dialogs/add-edit-soil-sample/add-edit-soil-sample.component';
import {
    NewDeletePinComponent
} from 'src/app/dialogs/pin-rework-dialogs/new-delete-pin/new-delete-pin.component';
import {MergeGroupsComponent} from 'src/app/dialogs/merge-groups/merge-groups.component';
import {GroupService} from 'src/app/services/group.service';
import {MoveSampleComponent} from 'src/app/dialogs/move-sample/move-sample.component';
import {DeleteSampleGroupComponent} from 'src/app/dialogs/delete-sample-group/delete-sample-group.component';
import {UpdateGroupComponent} from 'src/app/dialogs/update-group/update-group.component';
import {TenantService} from 'src/app/services/tenant.service';
import {PIN_ICONS} from "../../dialogs/pin-rework-dialogs/new-save-pin/new-save-pin.component";
import {GrowthStageModel} from "../../models/growth-stage";
import {SeasonManagerService} from "../../services/season-manager.service";
import {SampleGroupService} from '../../services/sample-group.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-all-samples',
    templateUrl: './all-samples.component.html',
    styleUrls: ['./all-samples.component.css'],
    standalone: false
})
export class AllSamplesComponent extends BaseService {
    allSamplesForm: FormGroup;

    @ViewChild(MatPaginator) paginatorAllPins: MatPaginator
    @ViewChild(MatSort) sort: MatSort;

    currentPage: number = 0;
    pageSize: number = 25;
    totalElements: number = 0;
    tableHeightDifference: number = 345;
    pinType: PinType;
    pintypeId: string = '0';
    groupId: number = 0;
    tenantId: string = null;

    groupName: string = '';
    mergeWithGroupId: number = 0;
    moveToGroupId: number = 0;

    protected readonly dayjs = dayjs;

    dateStringFormatting = 'YYYY-MM-DD';
    placeholder: string = "-";
    startDate: string;
    endDate: string;
    searchValue: string = null;
    isInitialLoad: boolean = false;
    growthStages: GrowthStageModel[] = [];

    displayedColumns: string[] = [
        'table-checkboxes',
        'table-farm',
        'table-field',
        'table-pinType',
        'table-sample',
        'table-dateCreated',
        'table-createdBy',
        'table-actions'];
    pinTypesList: PinType [] = [];
    groupInfo: SampleGroupInfo;
    filterStartDate: string = '';
    filterEndDate: string = '';
    tableHeight: string = '';
    

    dataSource = new MatTableDataSource<SampleGroupInfo>([]);
    selectedToMove = [];

    isSampleitemSelected: boolean = false;
    isNoItemsFound: boolean = false;
    showToolTip: boolean = false;
    initialLoad: boolean = false;
    isFilterBtnVisible: boolean = false;
    showPinTypeMenu: boolean = false;
    showPageSizeMenu: boolean = false;
    showExportMenu: boolean = false;

    // Side panel
    sidePanelOpen: boolean = false;
    editingSample: any = null;
    editSampleName: string = '';
    editSampleDepth: string = '';
    editRockPercentage: string = '';
    editSampleNote: string = '';
    editSelectedGroup: any = null;
    editSelectedGroupId: number = null;
    editPlantPartId: number = null;
    editGrowthStageLinkId: number = null;
    editIsCompleted: boolean = false;
    showEditGroupDropdown: boolean = false;
    showGrowthStageDropdown: boolean = false;
    showPlantPartDropdown: boolean = false;
    groups: any[] = [];
    plantParts: any[] = [];

    constructor(
        public helper: HelperService,
        private router: Router,
        public nav: NavBarComponent,
        private sampleService: SampleService,
        private pinManagerService: PinManagerService,
        public editSampleDialog: MatDialog,
        public mergeGroupDialog: MatDialog,
        public moveToDialog: MatDialog,
        public deleteGroupDialog: MatDialog,
        public editGroupDialog: MatDialog,
        private groupService: GroupService,
        private tenantService: TenantService,
        private seasonManagerService: SeasonManagerService,
        private sampleGroupService: SampleGroupService,
        private snackBar: MatSnackBar
    ) {
        super();

        this.allSamplesForm = new FormGroup({
            pinType: new FormControl(null)
        });
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        // if(window.innerHeight > 1200) {
        //     this.tableHeightDifference = 550 + (window.innerHeight * 0.08043818466);
        // } else {
        //     this.tableHeightDifference = 550;
        // }
        // 
        // 
        this.tableHeight = (window.innerHeight - this.tableHeightDifference) + 'px';
    }

    @HostListener('document:click')
    onDocumentClick() {
        this.showPinTypeMenu = false;
        this.showPageSizeMenu = false;
        this.showExportMenu = false;
        this.showEditGroupDropdown = false;
        this.showGrowthStageDropdown = false;
        this.showPlantPartDropdown = false;
    }


    ngOnInit() {

        //REFRESH & POPULATE LIST ON TENANT CHANGE/UPDATE
        this.tenantService.currenttenantId.subscribe(tenantId => {
            if (tenantId && this.isInitialLoad) {
                this.back();
            }
        });

        this.populatePinTypesListDropDown();


        this.pinType = this.allSamplesForm.controls.pinType.value;
        setTimeout(() => {
            this.setSelectedPinType(this.pinType);
        }, 800);

        if (sessionStorage.getItem('sampleGroupName') !== null) {
            this.groupName = sessionStorage.getItem('sampleGroupName');
        }

        const defaultStartDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
        const defaultEndDate = dayjs().format('YYYY-MM-DD');

        this.filterStartDate = defaultStartDate;
        this.filterEndDate = defaultEndDate;

        this.startDate = dayjs(this.filterStartDate).format('YYYY-MM-DD');
        this.endDate = dayjs(this.filterEndDate).format('YYYY-MM-DD');

        setTimeout(() => {
            this.populateSampleList();
        }, 500)

        this.isInitialLoad = true;
    }

    getFieldDetails(sample) {
        this.nav.toggleLoading(true);
        this.seasonManagerService.getDetailsOfFieldById(sample.field.id).subscribe({
            next: (res) => {
                this.getGrowthStageMetaData(res?.detail?.currentCrop, sample)
            },
            error: () => {
                this.openSoftTissueDialog(sample);
            }
        })
    }

    getGrowthStageMetaData(cropId: number, sample) {
        this.pinManagerService.getGrowthStageMetaData(cropId).subscribe({
            next: (res: GrowthStageModel[]) => {
                this.growthStages = res;
                this.openSoftTissueDialog(sample);
            },
            error: () => {
                this.openSoftTissueDialog(sample);
            }
        })
    }

    openSoftTissueDialog(sample) {
        this.nav.toggleLoading(false);
        const dialogRef = this.editSampleDialog.open(AddEditSoftTissueSampleComponent, {
            panelClass: 'compact-dialog',
            data: {

                pinId: sample?.pin?.id,
                userId: sample.user?.userId,
                tenantId: sample?.tenantId,
                isEditSampleMode: true,
                isAddNewSapleMode: false,
                sampleId: sample?.id,
                linkedGroup: sample?.sampleGroup,
                sampleName: sample?.name,
                plantPart: sample.softTissue.plantPart?.id,
                cropAge: sample.softTissue?.cropAge,
                note: sample?.note,
                pinCropGrowthStageLinkId: sample?.softTissue?.pinCropGrowthStageLinkId,
                growthStages: this.growthStages,
                isCompleted: sample?.isCompleted,
                seasonFieldDetailId: sample?.seasonFieldDetailId
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.populateSampleList();
        })
    }

    populatePinTypesListDropDown() {
        this.pinManagerService.getPinTypesList().pipe(
            catchError((error) => {
                console.error(error);
                return throwError(() => error);
            })
        )
            .subscribe((response) => {


                this.pinType = {
                    id: 0,
                    name: 'All',
                    dateModified: ' '
                }

                this.pinTypesList.push(this.pinType);

                for (let pinType of response) {
                    if (pinType?.name?.toLowerCase().includes('soil') || pinType?.name?.toLowerCase().includes('soft')) {
                        this.pinTypesList.push(pinType)
                    }
                }
                this.allSamplesForm.controls.pinType.setValue(this.pinType);

                this.nav.toggleLoading(false);
            });
    }

    populateSampleList() {
        this.nav.toggleLoading(true);

        this.groupId = Number(sessionStorage.getItem('sampleGroupId'));
        this.sampleService.getPaginatedSampleListByGroupId(
            this.groupId,
            this.currentPage,
            this.pageSize,
            this.searchValue,
            this.startDate,
            this.endDate,
            this.pinType?.id
        ).pipe(
            catchError(error => {
                console.error();
                return throwError(() => error);
            })
        ).subscribe((response) => {

            console.log(response)
            this.groupInfo = response.sampleGroupInfo;

            setTimeout(() => {
                this.dataSource.data = response.paginatedData.content;
                this.isNoItemsFound = response?.paginatedData?.content.length <= 0;
            }, 300)

            this.hideShowFilterReset();
            this.nav.toggleLoading(false);
            this.totalElements = response.paginatedData.totalElements;
        });

    }


    setSelectedPinType(pinType: PinType) {
        this.clearSelectedSamples();
        this.pinType = this.allSamplesForm.controls.pinType.value;
        this.allSamplesForm.controls.pinType.setValue(pinType);
        this.populateSampleList();
    }

    selectPinType(pt: PinType) {
        this.showPinTypeMenu = false;
        this.pinType = pt;
        this.allSamplesForm.controls.pinType.setValue(pt);
        this.clearSelectedSamples();
        this.populateSampleList();
    }


    toggleAllSelection(event: any): void {
        this.isSampleitemSelected = event.target.checked;
        this.dataSource.data.forEach(item => {
            this.onSampleSelectedChecked(event, item.id);
        });
    }


    onSampleSelectedChecked(event: any, id: number) {
        const checked = event?.target?.checked ?? event?.checked ?? false;
        if (checked) {
            if (!this.selectedToMove.includes(id)) {
                this.selectedToMove.push(id);
            }
        } else {
            const index = this.selectedToMove.indexOf(id);
            if (index > -1) {
                this.selectedToMove.splice(index, 1);
            }
        }
    }


    openMergeWithDialog() {

        const dialogRef = this.mergeGroupDialog.open(MergeGroupsComponent, {
            panelClass: 'compact-dialog',
            data: {
                userId: this.helper.getUserId(),
                tenantId: sessionStorage.getItem('selectedTenant'),
                selectedGroups: [this.groupId]
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.groupObj.option == 'merge') {
                this.mergeWithGroupId = result.groupObj.groupId;
                //
                this.mergeSelectedGroups();
                this.back();
            }
        });
    }

    mergeSelectedGroups() {

        this.groupService.updateMergeSampleGroups(this.groupId, this.mergeWithGroupId).pipe(
            catchError((error) => {
                console.error(error);
                return throwError(() => error);
            })
        )
            .subscribe((response) => {
                this.populateSampleList();
                // this.toggleAllSelection(response);
                this.nav.toggleLoading(false);
            });
    }

    openMoveSampleDialogDialog() {


        const dialogRef = this.moveToDialog.open(MoveSampleComponent, {
            panelClass: 'compact-dialog',
            data: {
                userId: this.helper.getUserId(),
                tenantId: sessionStorage.getItem('selectedTenant'),
                selectedGroups: [this.groupId]
            }
        });

        dialogRef.afterClosed().subscribe(result => {

            if (result.groupObj.option == 'move') {
                this.moveToGroupId = result.groupObj.groupId;


                this.moveSample();
            }
        });
    }


    moveSample() {

        this.selectedToMove.forEach((sampleId) => {

            if (sampleId !== null) {
                this.sampleService.moveSampleToGroup(sampleId, this.moveToGroupId).pipe(
                    catchError(error => {
                        console.error(error);
                        return throwError(() => error);
                    })
                ).subscribe((response) => {
                    this.selectedToMove = [];
                    this.populateSampleList();
                    this.toggleAllSelection(response);
                    this.nav.toggleLoading(false);
                });
            }
        })
    }


    searchSamples(searchValue: string) {
        this.searchValue = searchValue.trim().toLocaleLowerCase();
        setTimeout(() => {
            this.clearSelectedSamples();
            this.populateSampleList();
        }, 1400)
    }

    clearSelectedSamples() {
        for (let id of this.selectedToMove) {
            this.onSampleSelectedChecked(false, id);
        }
        this.selectedToMove = [];
        this.isSampleitemSelected = false;
    }

    onPaginateChange(event: PageEvent) {
        this.clearSelectedSamples()
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.totalElements = event.length;
        this.populateSampleList();
    }

    goToPage(page: number) {
        this.clearSelectedSamples();
        this.currentPage = page;
        this.populateSampleList();
    }

    onPageSizeChange() {
        this.currentPage = 0;
        this.clearSelectedSamples();
        this.populateSampleList();
    }

    get lastPage(): number {
        return Math.max(0, Math.ceil(this.totalElements / this.pageSize) - 1);
    }

    min(a: number, b: number): number {
        return Math.min(a, b);
    }

    viewSampleInfo(sample) {
        this.editingSample = sample;
        this.editSampleName = sample.name || '';
        this.editSampleNote = sample.note || '';
        this.editIsCompleted = sample.isCompleted || false;
        this.editSelectedGroup = this.groupInfo ? { id: this.groupInfo.id, name: this.groupInfo.name } : null;
        this.editSelectedGroupId = this.groupInfo?.id || null;
        console.log(this.groupInfo)

        if (sample.pinType?.id == 4) {
            this.editSampleDepth = sample.soil?.sampleDepth || '';
            this.editRockPercentage = sample.soil?.rockPercentage || '';
        } else if (sample.pinType?.id == 3) {
            this.editPlantPartId = sample.softTissue?.plantPart?.id || null;
            this.editGrowthStageLinkId = sample.softTissue?.pinCropGrowthStageLinkId || null;
            this.loadPlantParts();
            if (sample.field?.id) {
                this.loadGrowthStages(sample.field.id);
            }
        }

        this.loadGroups();
        this.sidePanelOpen = true;
    }

    closeSidePanel() {
        this.sidePanelOpen = false;
        this.editingSample = null;
    }

    selectEditGroup(g: any) {
        this.editSelectedGroup = g;
        this.editSelectedGroupId = g.id;
        this.showEditGroupDropdown = false;
    }

    getGrowthStageName(id: number): string {
        return this.growthStages.find(gs => gs.id === id)?.name || '';
    }

    getPlantPartName(id: number): string {
        return this.plantParts.find(pp => pp.id === id)?.name || '';
    }

    loadGroups() {
        const tenantId = Number(sessionStorage.getItem('selectedTenant'));
        this.groupService.getGroups(tenantId).pipe(
            catchError(e => { console.error(e); return throwError(() => e); })
        ).subscribe(res => this.groups = res);
    }

    loadPlantParts() {
        this.sampleService.getSoftTissuePlantPartList().pipe(
            catchError(e => { console.error(e); return throwError(() => e); })
        ).subscribe(res => this.plantParts = res);
    }

    loadGrowthStages(fieldId: number) {
        this.seasonManagerService.getDetailsOfFieldById(fieldId).subscribe({
            next: (res) => {
                this.pinManagerService.getGrowthStageMetaData(res?.detail?.currentCrop).subscribe({
                    next: (stages: any[]) => this.growthStages = stages || [],
                    error: () => this.growthStages = []
                });
            },
            error: () => this.growthStages = []
        });
    }

    updateSample() {
        const sample = this.editingSample;
        if (!sample) return;

        if (sample.pinType?.id === 4) {
            this.sampleService.updateSoilSample(
                sample.pin?.id, sample.id, this.editSelectedGroupId,
                this.editSampleName, this.editSampleDepth, this.editRockPercentage,
                this.editSampleNote, this.editIsCompleted
            ).subscribe(() => { this.closeSidePanel(); this.populateSampleList(); });
        } else if (sample.pinType?.id === 3) {
            this.sampleService.updateSoftTissueSample(
                sample.pin?.id, sample.id, this.editSelectedGroupId,
                this.editSampleName, this.editPlantPartId, this.editGrowthStageLinkId,
                this.editSampleNote, this.editIsCompleted
            ).subscribe(() => { this.closeSidePanel(); this.populateSampleList(); });
        }
    }

    deleteSample() {
        if (!this.editingSample) return;
        const dialogRef = this.editSampleDialog.open(NewDeletePinComponent, {
            panelClass: 'compact-dialog',
            data: {
                isBulkDelete: true,
                description: this.editSampleName || 'Sample',
                field: this.editingSample.field?.name || '-'
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result?.option === 'delete') {
                this.sampleService.deleteSampleById(this.editingSample.id)
                    .subscribe(() => { this.closeSidePanel(); this.populateSampleList(); });
            }
        });
    }

    hideShowFilterReset(){
        const defaultStartDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
        const defaultEndDate = dayjs().format('YYYY-MM-DD');
        if(this.startDate !== defaultStartDate || this.endDate !== defaultEndDate || this.searchValue || this.pinType.name !== 'All'){
          this.isFilterBtnVisible = true;
        }else{
          this.isFilterBtnVisible = false;
        }
      }

    filterDateRange() {
        if (this.filterEndDate && this.filterStartDate) {
            this.clearSelectedSamples();
            this.startDate = this.filterStartDate ? dayjs(this.filterStartDate).format('YYYY-MM-DD') : '';
            this.endDate = this.filterEndDate ? dayjs(this.filterEndDate).format('YYYY-MM-DD') : '';
            this.populateSampleList();
        }
    }

    back() {

        this.router.navigate(['/pin-manager/sample-groups']);
        sessionStorage.removeItem('sampleGroupId');
    }


    openDeleteGroupDialog() {

        const dialogRef = this.deleteGroupDialog.open(DeleteSampleGroupComponent, {
            panelClass: 'compact-dialog',
            data: {
                bulkDelete: false,
                groupId: this.groupId
            }
        });

        dialogRef.afterClosed().subscribe(result => {

            if (result.option === 'delete') {
                this.back();
            }
        });
    }

    openEditGroupDialog() {

        const dialogRef = this.editGroupDialog.open(UpdateGroupComponent, {
            panelClass: 'compact-dialog',
            data: {
                groupId: this.groupId,
                name: this.groupName
            }
        });

        dialogRef.afterClosed().subscribe(groupName => {

            if (groupName) {
                this.groupName = groupName;
            }
        });
    }


    resetFilter() {
        this.refreshBrowser();
    }

    refreshBrowser() {
        // FORCE REFRESH BROWSER
        this.router.navigateByUrl("/pin-manager/all-pins", {skipLocationChange: true}).then(() => {
            this.router.navigate([`/all-samples/${this.groupId}`]);
        });
    }

    exportSampleGroupAsExcel() {
        this.nav.toggleLoading(true);
        this.sampleGroupService.exportSampleGroupAsExcel(this.groupId, sessionStorage.getItem('selectedTenant')).subscribe({
            next: (response) => {
                const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
                const filename = `sample_group_${this.groupId}_export_${timestamp}.xlsx`;
                const link = document.createElement('a');
                link.href = response.download_url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.nav.toggleLoading(false);
            },
            error: () => {
                this.nav.toggleLoading(false);
                this.snackBar.open('Export failed — could not download Excel file.', 'close', { duration: 3000 });
            }
        });
    }

    exportSampleGroupAsShapefile() {
        this.nav.toggleLoading(true);
        this.sampleGroupService.exportSampleGroupAsShapefile(this.groupId, sessionStorage.getItem('selectedTenant')).subscribe({
            next: (response) => {
                const link = document.createElement('a');
                link.href = response.download_url;
                link.download = `sample_group_${this.groupId}_export.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.nav.toggleLoading(false);
            },
            error: () => {
                this.nav.toggleLoading(false);
                this.snackBar.open('Export failed — could not download Shapefile.', 'close', { duration: 3000 });
            }
        });
    }

    protected readonly pinIcons = PIN_ICONS;
}

